import { Step, StepButton, StepLabel, Stepper } from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import { FieldErrors } from 'react-hook-form';
import { AdHocExerciseFormData } from './ad-hoc/CreateAdHocExerciseDialog';
import { ExerciseFormData } from './scheduled/CreateExerciseDialog';

export interface CreateExerciseStepperProps {
  activeStep: number;
  errors: FieldErrors<ExerciseFormData>;
  setActiveStep: Dispatch<SetStateAction<number>>;
  steps: { label: string; fields: Array<keyof (ExerciseFormData | AdHocExerciseFormData)>; disabled?: boolean }[];
}

const CreateExerciseStepper = ({ activeStep, errors, setActiveStep, steps }: CreateExerciseStepperProps) => {
  return (
    <Stepper activeStep={activeStep} sx={{ mt: 2, mb: 3 }}>
      {steps.map(({ disabled, label, fields }, i) => {
        const StepComponent =
          activeStep > i ? props => <StepButton onClick={() => setActiveStep(i)} {...props} /> : React.Fragment;

        const stepHasError = Object.keys(errors).some(error => fields.includes(error as keyof ExerciseFormData));
        const labelProps = stepHasError ? { error: true } : {};

        return (
          <Step key={label}>
            <StepComponent>
              <StepLabel
                sx={{
                  opacity: disabled ? 0.5 : 1,
                  '.MuiStepLabel-label': {
                    display: { xs: 'none', sm: 'inline' },
                  },
                }}
                {...labelProps}
              >
                {label} {disabled && '(N/A)'}
              </StepLabel>
            </StepComponent>
          </Step>
        );
      })}
    </Stepper>
  );
};

export default CreateExerciseStepper;
